// extracted by mini-css-extract-plugin
module.exports = {"cardPlayerContainer":"style_cardPlayerContainer__22gsW"};